// Running rows ([data-autoscroll]): the track is duplicated once so the CSS
// marquee (store.css .ds-brandrow__track) loops seamlessly. No manual scrolling.
import { $$, reduceMotion } from "./util";

function run(row) {
	const track = row.firstElementChild;
	if (!track || track.dataset.cloned) return;
	track.dataset.cloned = "1";
	Array.from(track.children).forEach((c) => { const k = c.cloneNode(true); k.setAttribute("aria-hidden", "true"); k.tabIndex = -1; track.appendChild(k); });
}

export function initAutoscroll() {
	$$("[data-autoscroll]").forEach(run);
}
